import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Star, Sparkles, Phone, User } from "lucide-react";

const TABS = [
  { id: "home",    label: "Home",    path: "/",             icon: Home,     testid: "tab-home" },
  { id: "kundli",  label: "Kundli",  path: "/kundli",       icon: Star,     testid: "tab-kundli" },
  { id: "chat",    label: "AI Chat", path: "/chat",         icon: Sparkles, testid: "tab-chat" },
  { id: "consult", label: "Consult", path: "/consultation", icon: Phone,    testid: "tab-consult" },
  { id: "profile", label: "Profile", path: "/dashboard",    icon: User,     testid: "tab-profile" },
];

export default function BottomTabBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Hide on auth page (full-screen experience)
  if (pathname.startsWith("/auth")) return null;

  const matchTab = (path) => {
    if (path === "/") return pathname === "/";
    return pathname.startsWith(path);
  };

  return (
    <>
      <nav
        data-testid="bottom-tab-bar"
        className="bottom-tab-bar"
        aria-label="Primary"
      >
        {TABS.map(({ id, label, path, icon: Icon, testid }) => {
          const active = matchTab(path);
          return (
            <button
              key={id}
              data-testid={testid}
              onClick={() => navigate(path)}
              className={"tab-btn" + (active ? " tab-active" : "")}
              aria-current={active ? "page" : undefined}
            >
              <Icon size={20} strokeWidth={active ? 2.4 : 1.8} />
              <span className="tab-label">{label}</span>
            </button>
          );
        })}
      </nav>
      {/* Safe-area spacer so content isn't covered by the bar */}
      <div className="bottom-tab-spacer" aria-hidden="true" />
    </>
  );
}
